
<div #content>
  <ng-content></ng-content>
</div>


